import type { FaireProductEntity } from "../../entity_types/product";

export const p_n4846gbqsr: FaireProductEntity = {
  token: "p_n4846gbqsr",
  type: "product",
  name: "Creamy Calabrian Vodka (6 Pack)",
  brandToken: "b_ams77vmxsb",
  brandName: "Sauz",
  imageUrl:
    "https://cdn.faire.com/fastly/4957287d845c493436b3e7394abff1a1d02939241e936184f69bbe632ddb982f.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a805ed7c40b41ee9ae5a245b043cd2a5be35e2163580447dae24d9789715fd9e.png",
    "https://cdn.faire.com/fastly/102361ea227f1f58f84995bd0d400307f6ea00b94942cd4081c45a53ddea749e.png",
    "https://cdn.faire.com/fastly/1e197f8b6d56f9da9afe943278e4c05413aa2a910e8493bbc58f804c7499b533.jpeg",
    "https://cdn.faire.com/fastly/f2db26a01e60d3066304dfd7b6338c91d7f4a82ae692997cc061cff5f6cfb0b8.png",
  ],
  priceDollars: 38.94,
  description:
    "Thick, creamy... & oh so dreamy. Made with heavy cream, Calabrian chili peppers, and a splash of vodka, our Creamy Calabrian Vodka sauce is indulgent, rich, and velvety.\n\n✓ SEED OIL FREE\n✓ CALIFORNIA GROWN TOMATOES\n✓ 100% OLIVE OIL\n\nSauz is reimagining what pasta sauce can be. Our bold, original flavors go beyond the basics, made for customers who crave something different and can’t find it in the standard sauce aisle.\n\nWe use high-quality, clean ingredients with real aromatics, vibrant herbs, and 100% olive oil. No seed oils & no added sugar. Just rich, balanced flavor with a homemade feel, minus the effort.\n\nOur sauces fit perfectly into specialty markets, curated pantry collections, and premium gift sets. With eye-catching packaging and repeat-worthy flavor, it’s a standout on the shelf and a favorite in the kitchen.\n",
  tags: [],
  msrpDollars: 77.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:07.545Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
